import classNames from 'classnames';

import { css } from '@sorare/css';

import { Verified } from '#src/atoms/icons/Verified.tsx';

const root = css`
  color: var(--current-color);
  font: var(--t-12);
  font-weight: var(--t-bold);

  & svg {
    vertical-align: text-bottom;
    margin-right: var(--half-unit);
  }
  &.medium {
    font: var(--t-14);
  }
`;

type Props = {
  variant?: 'small' | 'medium';
};
export const SorareUser = ({ variant = 'small' }: Props) => {
  return (
    <span className={classNames(root, variant)}>
      <Verified />
      Sorare
    </span>
  );
};
